import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function AdminLogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/activity-logs"); setItems(data); })(); }, []);
  return (
    <div className="space-y-5">
      <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Log Attività</h1>
      <div className="card-elevated overflow-hidden">
        <table className="data-table w-full">
          <thead><tr><th>Data</th><th>Azione</th><th>Risorsa</th><th>Utente</th><th>Dettagli</th></tr></thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id}>
                <td className="text-xs">{fmtDateTime(l.created_at)}</td>
                <td className="!font-sans font-semibold">{l.action}</td>
                <td>{l.resource_type}</td>
                <td className="text-xs">{l.user_id}</td>
                <td className="text-xs">{JSON.stringify(l.metadata || {})}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="text-center text-slate-400 py-8">Nessun log</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
